import {
  Modal,
  ModalBody,
  ModalContent,
} from "@chakra-ui/react";
import { User } from "features/User/models";
import ProfileForm from "components/Forms/ProfileForm";
import { useUserDetailQuery } from "features/User/hooks";

interface EditProfileModalProps {
  userId: string | null;
  onClose: () => void;
  onSuccess?: () => void;
}

export function EditProfileModal({ userId, onClose, onSuccess }: EditProfileModalProps) {
  const { data: user } = useUserDetailQuery(userId as string, {
    enabled: !!userId,
  });

  const handleSave = () => {
    onClose();
    onSuccess?.();
  };

  return (
    <Modal size="5xl" isOpen={!!userId} onClose={onClose}>
      <ModalContent>
        <ModalBody>
          {user && <ProfileForm user={user as unknown as User} onSave={handleSave} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
